import somPedidoAtrasado from "../assets/sounds/order_alert.wav";

let audio;

// Navegadores só liberam áudio depois de alguma interação do usuário na página.
// Um F5 zera essa permissão, então o primeiro alerta após o reload seria sempre
// bloqueado. Por isso destravamos o áudio no primeiro gesto do usuário e, se um
// alerta acontecer antes disso, ele fica pendente para tocar nesse momento.
let liberado = false;
let alertaPendente = false;

const EVENTOS_INTERACAO = ["pointerdown", "keydown", "touchstart"];

export const RESULTADO_ALERTA = {
	TOCADO: "tocado",
	AGUARDANDO_INTERACAO: "aguardando-interacao",
	ERRO: "erro",
};

const getAudio = () => {
	if (!audio) {
		audio = new Audio(somPedidoAtrasado);
		audio.preload = "auto";
	}
	return audio;
};

const tocar = async () => {
	const alerta = getAudio();
	alerta.currentTime = 0;
	await alerta.play();
	liberado = true;
};

// Toca e pausa em volume zero só para o navegador marcar o elemento como
// liberado — a partir daí os alertas seguintes tocam sem depender de gesto
const liberarAudio = async () => {
	const alerta = getAudio();
	const volumeOriginal = alerta.volume;

	try {
		alerta.volume = 0;
		await alerta.play();
		alerta.pause();
		alerta.currentTime = 0;
		liberado = true;
	} catch (erro) {
		return;
	} finally {
		alerta.volume = volumeOriginal;
	}

	if (alertaPendente) {
		alertaPendente = false;
		tocar().catch((erro) =>
			console.log("alerta sonoro pendente não pôde ser tocado", erro),
		);
	}
};

const aoInteragir = () => {
	removerListeners();
	liberarAudio();
};

const removerListeners = () => {
	EVENTOS_INTERACAO.forEach((evento) =>
		document.removeEventListener(evento, aoInteragir),
	);
};

export const prepararAlertaSonoro = () => {
	if (liberado) {
		return removerListeners;
	}

	EVENTOS_INTERACAO.forEach((evento) =>
		document.addEventListener(evento, aoInteragir, { once: true }),
	);

	return removerListeners;
};

// Toca o alerta sonoro. Quando o navegador ainda não liberou o áudio, devolve
// AGUARDANDO_INTERACAO e o som sai sozinho no primeiro gesto do usuário — não é
// um erro a ser reportado. ERRO fica para falhas de verdade (arquivo, decode).
export const tocarAlertaPedidoAtrasado = async () => {
	try {
		await tocar();
		return RESULTADO_ALERTA.TOCADO;
	} catch (erro) {
		if (erro && erro.name === "NotAllowedError") {
			alertaPendente = true;
			return RESULTADO_ALERTA.AGUARDANDO_INTERACAO;
		}

		console.log("alerta sonoro não pôde ser tocado", erro);
		return RESULTADO_ALERTA.ERRO;
	}
};
